module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "page",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.create($event)
      }
    }
  }, [_c('div', {
    staticClass: "split"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_c('label', [_vm._v("\n          Название\n          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.s.title),
      expression: "s.title"
    }],
    attrs: {
      "type": "text",
      "maxlength": "60",
      "placeholder": _vm.p.title
    },
    domProps: {
      "value": _vm._s(_vm.s.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.s.title = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', [_c('label', [_vm._v("\n          Аннотация\n          "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.s.anno),
      expression: "s.anno"
    }],
    attrs: {
      "type": "text",
      "maxlength": "170",
      "rows": "3",
      "placeholder": _vm.p.anno
    },
    domProps: {
      "value": _vm._s(_vm.s.anno)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.s.anno = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "row",
      "justify-content": "space-between",
      "flex-wrap": "wrap"
    }
  }, [_c('div', [_c('label', [_vm._v("\n            Дата\n            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.s.date),
      expression: "s.date"
    }],
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": _vm._s(_vm.s.date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.s.date = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', [_c('label', [_vm._v("\n            Время\n            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.s.time),
      expression: "s.time"
    }],
    attrs: {
      "type": "time"
    },
    domProps: {
      "value": _vm._s(_vm.s.time)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.s.time = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', [_c('label', [_vm._v("\n          Место\n          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.s.place),
      expression: "s.place"
    }],
    attrs: {
      "type": "text",
      "placeholder": "211"
    },
    domProps: {
      "value": _vm._s(_vm.s.place)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.s.place = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', [_c('label', [_vm._v("\n          Цветовая схема\n          "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.s.theme),
      expression: "s.theme"
    }],
    on: {
      "change": function($event) {
        _vm.s.theme = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    },
    domProps: {
      "textContent": _vm._s('default')
    }
  }), _vm._v(" "), _vm._l((['gray', 'blue', 'green', 'orange', 'yellow', 'violet']), function(t) {
    return _c('option', {
      domProps: {
        "textContent": _vm._s(t)
      }
    })
  })], 2)])]), _vm._v(" "), _c('div', [_c('label', [_vm._v("\n          Ссылка\n          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.s.url),
      expression: "s.url"
    }],
    attrs: {
      "placeholder": _vm.event.title,
      "type": "url",
      "inputmode": "url"
    },
    domProps: {
      "value": _vm._s(_vm.s.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.s.url = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticStyle: {
      "background-color": "#f7f7f7",
      "font-size": "0.8em",
      "padding": "0 0.3em",
      "color": "#0d47a1"
    }
  }, [_vm._v("\n          meetups.sfedu.ru/" + _vm._s(_vm.link))])])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('event', {
    staticStyle: {
      "margin-top": "0"
    },
    attrs: {
      "e": _vm.event
    }
  })], 1)]), _vm._v("\n\n  Текст на отдельной странице\n  "), _c('div', {
    staticClass: "split"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_c('label', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.s.text),
      expression: "s.text"
    }],
    ref: "text",
    staticClass: "text",
    attrs: {
      "type": "text",
      "placeholder": _vm.p.text
    },
    domProps: {
      "value": _vm._s(_vm.s.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.s.text = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('extended', {
    ref: "preview",
    staticStyle: {
      "margin-top": "0"
    },
    attrs: {
      "e": _vm.event,
      "header": false
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "create"
  }, [_c('label', {
    attrs: {
      "for": "pass"
    }
  }, [_vm._v("Пароль:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pass),
      expression: "pass"
    }],
    staticStyle: {
      "width": "11em"
    },
    attrs: {
      "id": "pass",
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": _vm._s(_vm.pass)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pass = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "okay",
    attrs: {
      "type": "submit",
      "value": "Создать"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-54c923a4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/new.vue
// module id = 157
// module chunks = 1